/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 필터 토글 컴포넌트
 * 버전 : 1.0
 * 파일명 : ToggleTag.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================ 
 * 수정 : 2025-07-16, 강동형 : 저작권 추가, 기획 요구 변경에 따른 컴포넌트 분리
 *================================================================
 */

import { useEffect } from 'react'
import { Box, Button  } from '@mui/material'
import {styled} from '@mui/material'
import { useDialogStore } from 'src/stores/DialogStore';

// 필터 버튼 스타일
const FilterButton = styled(Button)(({ theme }) => ({
    margin: "5px",
    borderRadius: "20px",
    '&.selected': {
    backgroundColor: '#E5F4F8', 
    color: '#06799B',                        // 테두리와 글씨 색상
    border: '1px solid #06799B'         // 테두리 색상
    },
    '&.unselected': {
    backgroundColor: 'white',
    color: 'black',
    border: `1.5px solid ${theme.palette.grey[400]}`,
    },
}));

const TitleWrapper = styled('span')(({theme})=>({
    fontSize:'16px',
    fontWeight:500,
}))

const ToggleTag = () => {
    const temp_edu_level = useDialogStore((state)=>state.temp_edu_level)
    const temp_highschool_type = useDialogStore((state)=>state.temp_highschool_type)
    const toggleFilter = useDialogStore((state)=>state.toggleFilter)
    const syncField = useDialogStore((state)=>state.syncField)

    useEffect(()=>{
        syncField('edu_level','temp','base')
        syncField('highschool_type','temp','base')
    },[])

    const mapLevel: Record<number,string>={
        0: '전체',
        1 : '고등학교',
        2 : '전문대학교',
        3 : '대학교',
        4 : '기타홍보'
    }
    const mapHighSchool: Record<number,string>={
        0 : '전체',
        1 : '일반고',
        2 : '자사고',
        3 : '특목고',
        4 : '특성화고'
    }

  return (
    <>
        <TitleWrapper>
            학교
        </TitleWrapper>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: "5px"}}>
            {[0, 1, 2, 3, 4].map(level => (
            <FilterButton
                key={level}
                onClick={() => toggleFilter("temp_edu_level", level, 0)}
                className={temp_edu_level.includes(level) ? "selected" : "unselected"}
            >
                {mapLevel[level]}
            </FilterButton>
            ))}
        </Box>
        {(temp_edu_level.includes(0) || temp_edu_level.includes(1)) && (
            <>
        <TitleWrapper>
            고등학교
        </TitleWrapper>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: "5px"}}>
                {[0, 1, 2, 3, 4].map(type => (
                    <FilterButton
                    key={type}
                    onClick={() => toggleFilter("temp_highschool_type", type, 0)}
                    className={temp_highschool_type.includes(type) ? "selected" : "unselected"}
                    >
                    {mapHighSchool[type]}
                    </FilterButton>
                ))}
                </Box>
            </>
        )}
    </>
  )
}

export default ToggleTag